module.exports = __webpack_public_path__ + "assets/forbes.1eb6438d.svg";